// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  // baseUrl:'http://172.16.1.16:8001/v1/',  // local
  //   SocketUrl : "ws://172.16.1.16:8001/"
  baseUrl:'https://py-khanaexpress.mobiloitte.org/v1/',
  SocketUrl:'wss://py-khanaexpress.mobiloitte.org/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
 